module.exports = {"350125100":"樟城镇","350125101":"嵩口镇","350125102":"梧桐镇","350125103":"葛岭镇","350125104":"城峰镇","350125105":"清凉镇","350125106":"长庆镇","350125107":"同安镇","350125108":"大洋镇","350125200":"塘前乡","350125201":"富泉乡","350125202":"岭路乡","350125203":"赤锡乡","350125204":"洑口乡","350125205":"盖洋乡","350125206":"东洋乡","350125207":"霞拔乡","350125208":"盘谷乡","350125209":"红星乡","350125210":"白云乡","350125211":"丹云乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350125.json
// module id = 1171
// module chunks = 0